<template>
  <div style="background-color: rgb(245, 245, 245);">
    <headers></headers>
    <div class="title">
      <div class="auto">首页  >  认证考试  >  个人账户信息  >  培训经历</div>
    </div>
    <div class="padding250">
      <div class="auto">
        <!--为空时-->
        <div class="null" v-if="peixunList.length < 1">
          <img src="../../../assets/null.jpg" alt="">
          <p class="text">暂时没有培训经历哦~</p>
          <router-link to="/addpeixun"><Button  icon="ios-add-circle-outline">添加培训经历</Button></router-link>
          <a href="javascript:;" v-on:click="goBack">
            <Button style="margin-left: 10px;width: 80px;background-color: #2d8cf0;border-color: #2d8cf0;">返回</Button>
          </a>
        </div>
        <!--不为空时-->
        <div class="jiaoyu clearfix" v-else>
          <div class="titles">
            培训经历
            <a href="javascript:;" v-on:click="goBack">
              <Button style="margin-left: 10px;width: 80px;background-color: #2d8cf0;border-color: #2d8cf0;" class="pull-right">返回</Button>
            </a>
            <router-link to="/addpeixun"><Button icon="ios-add-circle-outline" class="pull-right">添加培训经历</Button></router-link>
          </div>
          <div class="list" v-for="item in peixunList">
            <div class="name">{{item.organizationContent}} <Button v-on:click="delPeixun(item)" class="pull-right">删除</Button></div>
            <ul>
              <li>
                培训机构：{{item.organization}}
              </li>
              <li class="text">培训时间：{{item.cultivatestartDate}} 至 {{item.cultivateendDate}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
    <Modal
      v-model="modal1"
      title="删除培训经历提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>您确定要删除该培训经历吗？</p>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getPeixun, delPeixun} from "../../../http"
  import headers from '../../template/header'
  import footers from '../../template/footer'
  export default {
    name: 'peixun',
    props: {},
    data() {
      return {
        showOrder: 'kaoshi',
        modal1: false,
        delPeixunId: '',
        peixunList: []
      };
    },
    methods: {
      ok(){
        delPeixun({trainId: this.delPeixunId}).then(res => {
          if(res.code == 200){
            this.$Notice.success({
              title: '培训经历提醒',
              desc: '删除培训经历成功',
              duration: 3,
            });
            this.getPeixun()
          }
        })
      },
      cancel(){
      },
      goBack(){
        this.$router.push({
          name: 'kaoshiAccount'
        })
      },
      getPeixun(){
        getPeixun().then(res => {
          this.peixunList = res.data.trainlist
          console.info(res.data)
        })
      },
      delPeixun(v){
        this.delPeixunId = v.id
        this.modal1 = true
      }
    },
    created() {
      this.getPeixun()
    },
    components: {
      headers,
      footers
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .null{
    text-align: center;
    padding: 200px 0;
    .text{
      font-size: 14px;
      color: #999;
      margin: 10px 0 60px;
    }
  }
  button{
    background-color: #B2936B;
    color: #fff;
    display: inline-block;
    width: 200px;
    height: 50px;
    text-align: center;
    border-radius: 5px;
    font-size: 18px;
  }
  .title{
    font-size: 14px;
    color: #fff;
    height: 60px;
    line-height: 60px;
    background-color: #2F261E;
    text-align: left;
  }
  .padding250 .auto{
    background-color: #fff;
    margin-top: 30px;
    .jiaoyu{
      padding: 40px;
      .titles{
        font-size: 20px;
        color: #000;
        margin-bottom: 70px;
        text-align: left;
      }
      .list{
        border-radius: 5px;
        padding: 30px;
        box-shadow: 0px 0px 10px #ececec;
        text-align: left;
        margin-bottom: 40px;
        margin-right: 50px;
        float: left;
        width: 535px;
        .name{
          font-size: 20px;
          color: #000;
          margin-bottom: 20px;
          button{
            border:1px solid #B2936B;
            color: #B2936B;
            font-size: 16px;
            background-color: #fff;
            width: 80px;
            height: 36px;
            line-height: 20px;
          }
        }
        li{
          font-size: 14px;
          color: #000;
          margin-bottom: 10px;
          .zhuanye{
            margin-left: 20px;
          }
        }
        .text{
          color: #666;
        }
        &:nth-child(2n+1){
          margin-right: 0;
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/examination/cultivate/peixun.vue